import { useEffect, useState, useRef } from "react";
import ExpressLocationModal from "../../ExpressLocationModal";
import {
    getDeliverySchedules,
    getShippingMethods,
    getShippingPrice,
} from "../../../services/shippingService";
import "./Step3Shipping.css";
import { ClockCheck } from "lucide-react";

const LOCAL_PROVINCE_ID = 8;


export default function Step3Shipping({
    selectedAddress,
    comment,
    setComment,
    shippingData,
    onShippingSelected,
    onShippingCleared,
    onBack,

}) {




    const isLocalProvince =
        Number(selectedAddress?.provinceId) ===
        LOCAL_PROVINCE_ID;

    //     console.log(isLocalProvince);

    const [deliveryMethod, setDeliveryMethod] = useState(
        shippingData?.method ?? ""
    );

    const [selectedSchedule, setSelectedSchedule] = useState(
        shippingData?.schedule ?? null
    );

    const [expressLocation, setExpressLocation] = useState(
        shippingData?.expressLocation ?? null
    );

    const [expressPrice, setExpressPrice] = useState(
        Number(shippingData?.expressPrice ?? 0)
    );

    const [selectedShippingPrice, setSelectedShippingPrice] = useState(
        Number(shippingData?.price ?? 0)
    );

    const [shippingMethods, setShippingMethods] = useState([]);

    const [schedules, setSchedules] = useState([]);

    const [showExpressModal, setShowExpressModal] = useState(false);

    const [loadingMethods, setLoadingMethods] = useState(true);

    const [loadingSchedules, setLoadingSchedules] = useState(false);

    const [loadingExpressPrice, setLoadingExpressPrice] = useState(false);

    const [loadingShippingPrice, setLoadingShippingPrice] = useState(false);

    const [error, setError] = useState(null);

    const addressKey = selectedAddress?.id ?? null;
    /*
    |--------------------------------------------------------------------------
    | Load delivery schedules
    |--------------------------------------------------------------------------
    */


    useEffect(() => {

        if (!shippingData) {

            setDeliveryMethod("");

            setSelectedSchedule(null);

            setExpressLocation(null);

            setExpressPrice(0);

            setSelectedShippingPrice(0);

            return;
        }


        setDeliveryMethod(
            shippingData.method ?? ""
        );

        setSelectedSchedule(
            shippingData.schedule ?? null
        );

        setExpressLocation(
            shippingData.expressLocation ?? null
        );

        setExpressPrice(
            Number(
                shippingData.expressPrice ?? 0
            )
        );

        setSelectedShippingPrice(
            Number(
                shippingData.price ?? 0
            )
        );

    }, [shippingData]);


    // useEffect(() => {

    //     /*
    //     |--------------------------------------------------------------------------
    //     | Parent cleared shipping
    //     |--------------------------------------------------------------------------
    //     */

    //     if (!shippingData) {

    //         setDeliveryMethod("");

    //         setSelectedSchedule(null);

    //         setExpressLocation(null);

    //         setExpressPrice(0);

    //         setSelectedShippingPrice(0);

    //         setError(null);

    //         return;
    //     }

    //     /*
    //     |--------------------------------------------------------------------------
    //     | Restore parent's shipping state
    //     |--------------------------------------------------------------------------
    //     */

    //     setDeliveryMethod(
    //         shippingData.method ?? ""
    //     );

    //     setSelectedSchedule(
    //         shippingData.schedule ?? null
    //     );

    //     setExpressLocation(
    //         shippingData.expressLocation ?? null
    //     );

    //     setExpressPrice(
    //         Number(
    //             shippingData.expressPrice ?? 0
    //         )
    //     );

    //     setSelectedShippingPrice(
    //         Number(
    //             shippingData.price ?? 0
    //         )
    //     );

    //     setError(null);

    // }, [
    //     shippingData
    // ]);

    const previousAddressIdRef = useRef(null);

    useEffect(() => {

        if (!addressKey) {

            previousAddressIdRef.current = null;

            setDeliveryMethod("");
            setSelectedSchedule(null);
            setExpressLocation(null);
            setExpressPrice(0);
            setSelectedShippingPrice(0);
            setError(null);

            onShippingSelected?.(null);

            return;
        }

        const previousAddressId =
            previousAddressIdRef.current;

        // Address actually changed
        if (
            previousAddressId !== null &&
            previousAddressId !== addressKey
        ) {

            setDeliveryMethod("");
            setSelectedSchedule(null);
            setExpressLocation(null);
            setExpressPrice(0);
            setSelectedShippingPrice(0);
            setError(null);

            onShippingSelected?.(null);
        }

        previousAddressIdRef.current =
            addressKey;

    }, [addressKey, onShippingSelected]);


    useEffect(() => {

        const loadShippingMethods = async () => {

            try {

                setLoadingMethods(true);

                setError(null);

                const methods =
                    await getShippingMethods();

                setShippingMethods(methods);

            } catch (error) {

                console.error(
                    "Failed to load shipping methods:",
                    error
                );

                setError(
                    "امکان دریافت روش‌های ارسال وجود ندارد."
                );

            } finally {

                setLoadingMethods(false);
            }
        };

        loadShippingMethods();

    }, []);

    useEffect(() => {

        if (
            deliveryMethod !== "normal-post"
        ) {

            setSchedules([]);

            setSelectedSchedule(null);

            return;

        }


        const loadSchedules = async () => {

            try {

                setLoadingSchedules(true);

                setError(null);


                const data =
                    await getDeliverySchedules();

                console.log("getDeliverySchedules:", data)


                setSchedules(data);


            } catch (error) {

                console.error(
                    "Failed to load schedules:",
                    error
                );


                setError(
                    "Unable to load delivery schedules."
                );


            } finally {

                setLoadingSchedules(false);

            }

        };


        loadSchedules();

    }, [deliveryMethod]);


    const selectedShippingMethod =
        shippingMethods.find(
            (method) =>
                method.code === deliveryMethod
        );
    /*
    |--------------------------------------------------------------------------
    | Select Delivery Method
    |--------------------------------------------------------------------------
    */

    const handleMethodSelect = async (methodCode) => {

        setError(null);

        /*
        |--------------------------------------------------------------------------
        | Update local selection
        |--------------------------------------------------------------------------
        */

        setDeliveryMethod(methodCode);

        setSelectedSchedule(null);

        setExpressLocation(null);

        setExpressPrice(0);

        setSelectedShippingPrice(0);

        setShowExpressModal(false);


        /*
        |--------------------------------------------------------------------------
        | Find method
        |--------------------------------------------------------------------------
        */

        const method = shippingMethods.find(
            (item) => item.code === methodCode
        );


        if (!method) {

            setDeliveryMethod("");

            setError(
                "روش ارسال انتخاب شده پیدا نشد."
            );

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | API-based shipping
        |--------------------------------------------------------------------------
        */

        if (method.isApi) {

            setShowExpressModal(true);

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Calculate shipping price
        |--------------------------------------------------------------------------
        */

        try {

            setLoadingShippingPrice(true);

            const result =
                await getShippingPrice({
                    code: method.code,
                });


            setSelectedShippingPrice(
                Number(result?.price ?? 0)
            );

        } catch (error) {

            console.error(
                "Shipping price error:",
                error
            );


            setDeliveryMethod("");

            setSelectedShippingPrice(0);

            setError(
                error?.response?.data?.message ??
                "امکان دریافت هزینه ارسال وجود ندارد."
            );

        } finally {

            setLoadingShippingPrice(false);

        }

    };

    /*
    |--------------------------------------------------------------------------
    | Express Location
    |--------------------------------------------------------------------------
    */

    const handleLocationConfirm = async (
        position
    ) => {

        try {

            setLoadingExpressPrice(true);

            setError(null);

            setExpressLocation(position);

            const result =
                await getShippingPrice({

                    code: "express-post",

                    lat: position.lat,

                    lng: position.lng,

                });

            const price =
                Number(
                    result?.price ?? 0
                );

            if (price <= 0) {

                throw new Error(
                    "هزینه ارسال فوری معتبر نیست."
                );
            }

            setExpressPrice(price);

            setSelectedShippingPrice(price);

            setShowExpressModal(false);

        } catch (error) {

            console.error(
                "Failed to calculate express price:",
                error
            );

            setError(
                error.response?.data?.errors
                    ?.shipping?.[0]
                ??
                error.response?.data?.message
                ??
                error.message
                ??
                "امکان محاسبه هزینه ارسال فوری وجود ندارد."
            );

        } finally {

            setLoadingExpressPrice(false);
        }
    };


    const handleContinue = () => {

        setError(null);


        if (!deliveryMethod) {

            setError(
                "لطفاً روش ارسال را انتخاب کنید."
            );

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Normal Post requires schedule
        |--------------------------------------------------------------------------
        */

        if (
            deliveryMethod === "normal-post" &&
            !selectedSchedule
        ) {

            setError(
                "لطفاً زمان ارسال را انتخاب کنید."
            );

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | API shipping requires location
        |--------------------------------------------------------------------------
        */

        const selectedMethod =
            shippingMethods.find(
                (item) =>
                    item.code === deliveryMethod
            );


        if (!selectedMethod) {

            setError(
                "روش ارسال انتخاب شده معتبر نیست."
            );

            return;

        }


        if (
            selectedMethod.isApi &&
            (
                !expressLocation ||
                !expressPrice
            )
        ) {

            setError(
                "لطفاً موقعیت تحویل را انتخاب کنید."
            );

            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Build final shipping object
        |--------------------------------------------------------------------------
        */

        const shipping = {

            id:
                selectedMethod.id,

            method:
                selectedMethod.code,

            title:
                selectedMethod.title ??
                selectedMethod.name ??
                "",

            price:
                Number(
                    selectedShippingPrice ||
                    expressPrice ||
                    0
                ),

            schedule:
                selectedSchedule,

            expressLocation:
                expressLocation,

            expressPrice:
                Number(
                    expressPrice || 0
                ),

            // displayText:
            //     buildShippingDisplayText(
            //         selectedMethod,
            //         selectedSchedule
            //     ),

        };


        /*
        |--------------------------------------------------------------------------
        | ONLY HERE save to parent
        |--------------------------------------------------------------------------
        */

        onShippingSelected?.(
            shipping
        );

    };

    /*
    |--------------------------------------------------------------------------
    | No Address
    |--------------------------------------------------------------------------
    */

    if (!selectedAddress) {

        return (

            <section className="checkout-step shipping-step">

                <div className="shipping-error">

                    <h2>
                        آدرس الزامی است
                    </h2>


                    <p>
                        لطفاً ابتدا آدرس تحوبل را انتخاب کنید.
                    </p>


                    <button
                        type="button"
                        className="checkout-secondary-btn"
                        onClick={onBack}
                    >
                        ← مرحله قبل
                    </button>

                </div>

            </section>

        );

    }


    console.log("schedules:", schedules);
    console.log("selectedSchedule:", selectedSchedule);


    return (

        <section className="checkout-step shipping-step">


            <div className="shipping-address-summary">

                <div>

                    <span>
                        آدرس تحویل مشتری :

                    </span>

                    <strong>
                        {selectedAddress.fname}
                        {" "}
                        {selectedAddress.lname}
                    </strong>
                    <p>
                        {selectedAddress.province}
                        {" - "}
                        {selectedAddress.city}
                        {" - "}
                        {selectedAddress.address}
                    </p>

                </div>


                <button
                    type="button"
                    onClick={onBack}
                >
                    تغییر آدرس
                </button>

            </div>


            {/* ================================
                DELIVERY METHODS
            ================================= */}

            <div className="shipping-method-section">

                <h2>
                    انتخاب روش ارسال
                </h2>




                <div className="shipping-methods">

                    {loadingMethods ? (

                        <div className="shipping-method-loading">
                            در حال دریافت روش‌های ارسال...
                        </div>

                    ) : (

                        shippingMethods
                            .filter((method) => {

                                if (
                                    isLocalProvince
                                ) {

                                    return [
                                        "normal-post",
                                        "express-post",
                                        "attended-delivery"
                                    ].includes(
                                        method.code
                                    );
                                }

                                return [
                                    "post",
                                    "tipax"
                                ].includes(
                                    method.code
                                );

                            })
                            .map((method) => (

                                <button
                                    key={method.id}
                                    type="button"
                                    className={
                                        deliveryMethod ===
                                            method.code
                                            ? "shipping-method-card active"
                                            : "shipping-method-card"
                                    }
                                    onClick={() =>
                                        handleMethodSelect(
                                            method.code
                                        )
                                    }
                                >

                                    <span className="shipping-method-icon">

                                        {method.code ===
                                            "express-post"
                                            ? "⚡"
                                            : method.code ===
                                                "tipax"
                                                ? "🚚"
                                                : method.code ===
                                                    "attended-delivery"
                                                    ? "🏪"
                                                    : "📦"}

                                    </span>

                                    <span className="shipping-method-content">

                                        <strong>
                                            {method.title}
                                        </strong>

                                        {method.description && (

                                            <small>
                                                {method.description}
                                            </small>

                                        )}

                                    </span>

                                    <span className="shipping-method-price">

                                        {method.code ===
                                            "express-post"
                                            ? (
                                                expressPrice
                                                    ? `${expressPrice.toLocaleString("en-US")}`
                                                    : "محاسبه پس از انتخاب مکان"
                                            )
                                            : (
                                                selectedShippingMethod?.code ===
                                                    method.code
                                                    &&
                                                    loadingShippingPrice
                                                    ? "..."
                                                    : Number(
                                                        method.price ?? 0
                                                    ).toLocaleString("en-US")
                                            )}

                                    </span>

                                    <span className="shipping-method-check">

                                        {deliveryMethod ===
                                            method.code
                                            ? "✓"
                                            : ""}

                                    </span>

                                </button>

                            ))

                    )}

                </div>

            </div>


            {/* ================================
                NORMAL POST
            ================================= */}

            {selectedShippingMethod?.code === "normal-post" && (

                <div className="shipping-info-card">

                    <h3>
                        ارسال عادی
                    </h3>


                    <p>
                        توضیحات ارسال عادی
                    </p>


                    <div className="schedule-section">

                        <h4>
                            <ClockCheck />
                            <span className="schedule-Title-header"> انتخاب زمان ارسال</span>
                        </h4>


                        {loadingSchedules ? (

                            <p>
                                در حال فراخوانی بازه های زمانی ارسال...
                            </p>

                        ) : (

                            // <div className="schedule-list">

                            //     {schedules.map(
                            //         (schedule) => (

                            //             <label
                            //                 key={schedule.id}
                            //                 className={
                            //                     selectedSchedule?.id === schedule.id
                            //                         ? "schedule-option selected"
                            //                         : "schedule-option"
                            //                 }
                            //             >

                            //                 <input
                            //                     type="radio"
                            //                     name="deliverySchedule"
                            //                     checked={
                            //                         selectedSchedule?.id === schedule.id
                            //                     }
                            //                     onChange={() =>
                            //                         setSelectedSchedule(schedule)
                            //                     }
                            //                 />


                            //                 <span>
                            //                     {schedule.label}
                            //                 </span>

                            //             </label>

                            //         )
                            //     )}

                            // </div>

                            <div className="schedule-list">
                                {schedules.map((schedule) => {
                                    const isSelected =
                                        String(selectedSchedule?.id) === String(schedule.id);

                                    return (
                                        <button
                                            key={schedule.id}
                                            type="button"
                                            className={`schedule-option ${isSelected ? "selected" : ""
                                                }`}
                                            onClick={() => {
                                                setSelectedSchedule(schedule);
                                                setError(null);
                                            }}
                                        >
                                            <span className="schedule-radio">
                                                {isSelected && (
                                                    <span className="schedule-radio-dot" />
                                                )}
                                            </span>

                                            <span className="schedule-label">
                                                {schedule.label}
                                            </span>

                                            {isSelected && (
                                                <span className="schedule-check">
                                                    ✓
                                                </span>
                                            )}
                                        </button>
                                    );
                                })}
                            </div>
                        )}

                    </div>

                </div>

            )}


            {/* ================================
                EXPRESS DELIVERY
            ================================= */}

            {deliveryMethod === "express-post" && (

                <div className="shipping-info-card express-info-card">

                    <div>

                        <h3>
                            ارسال فوری
                        </h3>


                        <p>
                            جهت محاسبه هزینه ارسال موقعیت خود را روی نقشه انتخاب نمائید.
                        </p>

                    </div>


                    {!expressLocation ? (

                        <button
                            type="button"
                            className="checkout-primary-btn"
                            onClick={() =>
                                setShowExpressModal(true)
                            }
                        >
                            انتخاب موقعیت
                        </button>

                    ) : (

                        <div className="express-location-selected">

                            <div>

                                <strong>
                                    موقعیت انتخاب شده
                                </strong>


                                <span>
                                    Lat:{" "}
                                    {
                                        expressLocation.lat
                                    }
                                </span>


                                <span>
                                    Lng:{" "}
                                    {
                                        expressLocation.lng
                                    }
                                </span>

                            </div>


                            <button
                                type="button"
                                onClick={() =>
                                    setShowExpressModal(true)
                                }
                            >
                                Change
                            </button>

                        </div>

                    )}


                    {loadingExpressPrice && (

                        <p>
                            Calculating delivery price...
                        </p>

                    )}


                    {expressPrice > 0 && (

                        <div className="express-price">

                            Delivery Price:

                            <strong>
                                {expressPrice.toLocaleString(
                                    "en-US"
                                )}
                            </strong>

                        </div>

                    )}

                </div>

            )}


            {/* ================================
                ATTENDED DELIVERY
            ================================= */}

            {selectedShippingMethod?.code ===
                "attended-delivery" && (

                    <div className="shipping-info-card">

                        <h3>
                            تحویل حضوری
                        </h3>


                        <p>
                            در صورت انتخاب تحویل حضوری(به جز ایام تعطیل ) بلافاصله بعد از ثبت سفارش، می توانید سفارش خود را از محل داروخانه تحویل بگیرید. ( پرداخت به صورت اینترنتی می باشد )
                        </p>




                    </div>

                )}


            {/* ================================
                POST
            ================================= */}

            {selectedShippingMethod?.code === "post" && (

                <div className="shipping-info-card">

                    <h3>
                        ارسال توسط پست
                    </h3>


                    <p>
                        ارسال مرسوله توسط شرکت پست ملی ایران انجام می شود.
                    </p>


                    <p>
                        زمان تحویل بستگی به استان و شهر شما دارد.
                    </p>

                </div>

            )}


            {/* ================================
                TIPAX
            ================================= */}

            {selectedShippingMethod?.code === "tipax" && (

                <div className="shipping-info-card">

                    <h3>
                        ارسال توسط تیپاکس
                    </h3>


                    <p>
                        هزینه ارسال به صورت پس کرایه و به عهده مشتری می باشد.
                    </p>


                    <p>
                        تحویل مرسوله توسط تیپاکس معمولا سریعتر از پست می باشد.
                    </p>

                </div>

            )}


            {/* ================================
                ERROR
            ================================= */}

            {error && (

                <div className="shipping-error-message">

                    {error}

                </div>

            )}


            {/* ================================
                ACTIONS
            ================================= */}

            <div className="checkout-step-actions">

                <button
                    type="button"
                    className="checkout-secondary-btn"
                    onClick={onBack}
                >
                    →  مرحله قبل
                </button>


                <button
                    type="button"
                    className="checkout-primary-btn"
                    onClick={handleContinue}
                >
                    ثبت و مرحله بعد

                    <span className="checkout-btn-arrow">
                        ←
                    </span>
                </button>

            </div>


            {/* ================================
                EXPRESS LOCATION MODAL
            ================================= */}

            {showExpressModal && (

                <ExpressLocationModal

                    onConfirm={
                        handleLocationConfirm
                    }

                    onClose={() =>
                        setShowExpressModal(false)
                    }

                />

            )}

        </section>

    );

}